import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { connect } from 'react-redux';

import Button from '../../../components/Button/Button';
import FieldText from '../../../components/FieldText/FieldText';
import Select from '../../../components/Select/Select';

import './prospect-form.scss';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { validatehCaptchaToken } from '../../../state-management/actions/hCaptcha';



const ClientProspectForm = (props) => {
    const {
        errors,
        handleSubmit,
        registerData,
        isValid,
    } = props;

    const [token, setToken] = useState("");
    const [error, setError] = useState("");
    const captcha = useRef();
    const [termsAccepted, acceptTerms] = useState(false);
    const handleChange = () => {
        acceptTerms(!termsAccepted);
    };

    async function handleValidateToken(token) {
        const result = await validatehCaptchaToken(token);
        if (result) {
            setToken(token);
            setError("");
        } else {
            setError("Failed, Please verify captcha again");
            setToken("");
        }

    }

    const industryOptions = registerData.industries
        .map(item => ({ ...item, value: item.industry, name: item.industry }));

    return (
        <form className="prospect-form" noValidate onSubmit={handleSubmit}>
            <Field
                ariaDescribedby="prospect-errors"
                component={FieldText}
                name="firstName"
                label="First Name"
                required
            />
            <Field
                ariaDescribedby="prospect-errors"
                component={FieldText}
                name="lastName"
                label="Last Name"
                required
            />
            <Field
                ariaDescribedby="prospect-errors"
                component={FieldText}
                name="email"
                label="Email"
                required
            />
            <Field
                ariaDescribedby="prospect-errors"
                component={FieldText}
                name="company"
                label="Company"
                required
            />

            <Field
                ariaDescribedby="prospect-errors"
                component={FieldText}
                name="phoneNumber"
                label="Phone Number"
                required
                type="text"
            />
            <Field
                ariaDescribedby="prospect-errors"
                component={FieldText}
                name="title"
                label="Job Title"
                required
            />
            <Field
                component={Select}
                name="industry"
                label="Industry"
                required
                options={industryOptions}
            />
            <div className='prospect-form__controls'>
                <input
                    type="checkbox"
                    disabled={false}
                    name={'accept-terms'}
                    label={'Terms'}
                    onChange={handleChange}
                    className="prospect-form__checkbox"
                />
                <a
                    href='https://assess.chally.com/Chally_Terms_and_Conditions_Sept2020.pdf'
                    target='_blank'
                    rel='noreferrer'
                >
                    Accept terms and conditions
                </a>
            </div>
            <div className="prospect-form__errors" id="prospect-errors">
                {errors.authorization}
            </div>
            <div className='prospect-form__controls'>
                <HCaptcha
                    ref={captcha}
                    sitekey="eb886872-e6e9-4dd7-b189-62f264f06806"
                    onVerify={token => handleValidateToken(token)}
                    onExpire={() => setToken("")}
                />
            </div>
            <div className="prospect-form__errors" id="prospect-errors">
                {error && <p className='text-danger'>{error}</p>}
            </div>
            <div className="prospect-form__controls">
                <Button
                    type="submit"
                    disabled={!token || !termsAccepted || !isValid}
                >
                    Take the Assessment
                </Button>
            </div>
        </form >
    );
};

ClientProspectForm.propTypes = {
    errors: PropTypes.objectOf(PropTypes.string).isRequired,
    handleSubmit: PropTypes.func,
    resetPasswordFail: PropTypes.func,
    validatehCaptchaToken: PropTypes.func,
};
ClientProspectForm.defaultProps = {
    resetPasswordFail: () => { },
    handleSubmit: () => { },
    validatehCaptchaToken: () => { },
    registerData: {
        solutions: [],
        companySizes: [],
        industries: [],
    },
};
const mapStateToProps = (state) => ({
    registerData: state.prospect.registerData,

});

const mapDispatchToProps = dispatch => ({
    validateHCaptchaToken: (token) =>
        dispatch(validatehCaptchaToken(token)),

});

export default connect(mapStateToProps, mapDispatchToProps)(ClientProspectForm);

export { ClientProspectForm };
